import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import React from "react";
import { RemediationPackagesType } from "~/components/Remediation/types";
import { RemediationCheckboxSkeleton } from "../RemediationFilter/RemediationCheckboxSkeleton";

export type Props = {
  isLoading: boolean;
  remediationPackages: RemediationPackagesType;
  selectedPackages: string[];
  handlePackagesChange: (
    _event: React.ChangeEvent<HTMLInputElement>,
    id: string,
  ) => void;
};

export const IndividualPackages = ({
  remediationPackages,
  selectedPackages,
  handlePackagesChange,
  isLoading,
}: Props) => {
  return isLoading ? (
    <RemediationCheckboxSkeleton />
  ) : (
    <Grid container data-testid="remediation-packages">
      {remediationPackages.map((e) => (
        <Grid key={e.id} size={{ xs: 12, md: 6, lg: 3 }}>
          <FormControlLabel
            control={
              <Checkbox
                name={e.id}
                checked={selectedPackages.includes(e.id)}
                onChange={(event) => handlePackagesChange(event, e.id)}
              />
            }
            label={e.name}
          />
        </Grid>
      ))}
    </Grid>
  );
};
